import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "有効化しますか？", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      action: _ctx.state.action,
      method: "POST"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("p", null, _toDisplayString(_ctx.state.stripe.title), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.state.stripe.description), 1),
        _createVNode(_component_el_button, {
          round: true,
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode("有効化")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["action"])
  ]))
}